import SideNav from "react-sidenav";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import Main from "../Main";
import "./index.css";

const SideBar = (props) => {
  const user = useSelector((state) => state.auth.user);

  return (
    <div>
      {user && (
        <div className="parent">
          <div className="sidebar">
            <SideNav
              highlightColor="#E91E63"
              highlightBgColor="#00bcd4"
              defaultSelected="sales"
            >
              <Link to="/admin/products" className="lc-side-link">
                <h4 className="lc-side-header"> Products </h4>
              </Link>
              <Link
                to="/admin/product-compatibilities"
                className="lc-side-link"
              >
                <h4 className="lc-side-header"> Product Compatibilities </h4>
              </Link>
              <Link
                to="/admin/base-product-metadata"
                className="lc-side-link"
              >
                <h4 className="lc-side-header"> Base product metadata </h4>
              </Link>
              <Link to="/admin/quotes" className="lc-side-link">
                <h4 className="lc-side-header"> Quotes </h4>
              </Link>
              <Link to="/admin/groups" className="lc-side-link">
                <h4 className="lc-side-header"> Groups </h4>
              </Link>
              {user?.userGroup?.name === "admin" && (
                <Link to="/admin/users" className="lc-side-link">
                  <h4 className="lc-side-header"> Users </h4>
                </Link>
              )}
            </SideNav>
          </div>
          <div className="main">
            <Main {...props} />
          </div>
        </div>
      )}
      {!user && (
        <div className="main">
          <Main {...props} />
        </div>
      )}
    </div>
  );
};

export default SideBar;
